module.exports = __webpack_public_path__ + "static/media/solidity-beginner.a88c2eb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/solidity-beginner.png
// module id = 1473
// module chunks = 147